import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Header.css';

const Header: React.FC = () => {
  const { isAuthenticated, guestName, logout } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return null;
  }

  return (
    <header className="header">
      <div className="header-content">
        <div className="user-section">
          <span className="guest-name">Bienvenue, {guestName}</span>
          <button onClick={logout} className="logout-btn">Déconnexion</button>
        </div>
        <nav className="nav">
          <Link 
            to="/info" 
            className={location.pathname === '/info' ? 'nav-link active' : 'nav-link'}
          >
            Infos mariage
          </Link>
          <Link 
            to="/dashboard" 
            className={location.pathname === '/dashboard' ? 'nav-link active' : 'nav-link'}
          >
            RSVP
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
